import { MembershipValue } from '../constants/membershipDomainConstants';
import { clients, placements, PLACEMENT_IDS } from '../constants/moduleConstants';

// All of this is Partial to allow for backwards compatibility
type ConstructOneDataBodyParams = Partial<{
  locale: string;
  clientId: typeof clients extends Set<infer T> ? T : never;
  placementId: typeof placements extends Set<infer T> ? T : never;
}>;

type MembershipData = {
  data: {
    membership?: MembershipValue[];
  }
}

export const constructOneDataBody = (
  {
    locale, clientId, placementId,
  }: ConstructOneDataBodyParams,
  membershipData?: MembershipData
) => {
  const oneDataBody: Record<string, unknown> = {
    clientId,
    placementId,
    locale,
  };

  switch (placementId) {
    case PLACEMENT_IDS.GET_INSPIRED_PLACEMENT:
      const accountToken = membershipData?.data?.membership
        ?.find((membership: MembershipValue) => membership?.demographics?.isTopCard)
        ?.accountToken;

      if (!accountToken) {
        break;
      }

      oneDataBody.personalizationParam = {
        accountToken,
      };
      break;

    default:
      break;
  }

  return oneDataBody;
};
